import React from 'react';
import {connect} from 'react-redux';
import {TablePagination} from '@mui/material';
import './TablePaginator.scss';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */

const TablePaginator = (props) => {
  const {pageQuantity, currentPage, setCurrentPage, rowsPerPage, onRowsPerPageChange} = props;

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage + 1);
  };

  return (
    <div className="pag-div-pagination">
      <TablePagination
        component={'div'}
        count={pageQuantity|| 10}
        page={currentPage - 1}
        onPageChange={handleChangePage}
        labelRowsPerPage={'Filas por pagina'}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

TablePaginator.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(TablePaginator);
